import WithLoader from "~/ui-rtk/components/layout/WithLoader/WithLoader"
import useConnect from "./connect"
import HomeDashboard from "~/ui-rtk/components/features/dashboards/HomeDashboard/HomeDashboard"

import useDate from "~/ui-rtk/hooks/date"
const dayjs = useDate()

const dateRestrictions = { maxDate: dayjs().subtract(7, "day").toDate() }

export default function HomePage() {
  const { content } = useConnect()

  return (
    <div className="h-full px-4 py-2 bg-basic-black text-basic-light">
      <WithLoader isLoading={false}>
        <HomeDashboard
          slug={content.slug}
          title={content.title}
          dateRangeRestrictions={dateRestrictions}
          items={content.items}
        />
      </WithLoader>
    </div>
  )
}
